if (!customElements.get('ea-hover-video')) {
  customElements.define('ea-hover-video', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-card-wrapper, .ea-product-card');
      if (!this.card) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.start = () => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover: hover)').matches) return;
        this.active = true;
        if (!this.video) {
          this.append(this.querySelector('template').content.cloneNode(true));
          this.video = this.querySelector('video');
          this.video.muted = true;
          this.video.playsInline = true;
        }
        this.video.play().then(() => {
          if (this.active) this.setAttribute('playing', '');
          else this.video.pause();
        }).catch(() => this.removeAttribute('playing'));
      };
      this.stop = () => {
        this.active = false;
        this.removeAttribute('playing');
        if (this.video) this.video.pause();
      };
      this.card.addEventListener('pointerenter', this.start, options);
      this.card.addEventListener('pointerleave', this.stop, options);
      this.card.addEventListener('focusin', this.start, options);
      this.card.addEventListener('focusout', event => { if (!this.card.contains(event.relatedTarget)) this.stop(); }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, options);
      this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.stop(); });
      this.observer.observe(this.card);
    }
    disconnectedCallback() { this.stop?.(); this.abort?.abort(); this.observer?.disconnect(); }
  });
}
